module.exports = __webpack_public_path__ + "static/media/King Tiger.a95dd53e.png";